import { Component } from '@theme/component';

export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;
      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
    videoElement.addEventListener('canplay', () => {
      videoElement.play().catch(() => {});
    }, { once: true });
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}